import { ApexOptions } from "apexcharts";
import ReactApexChart from "react-apexcharts";
import { formatNumber } from "../../../utils/utils";
import { useThemeMode } from "../../../theme/ThemeContext";

interface ChartSeries {
  name: string;
  data: number[];
}

interface AreaChartProps {
  total?: number[];
  date?: string[]
  type?: any;
  color?: string;
  colors?: string[];
  series?: ChartSeries[];
}

const AreaChart = (props: AreaChartProps) => {
    const { mode, isDark } = useThemeMode();
    const axisColor = isDark ? "#a6a6a6" : "#595959";
    const series = props.series ?? [{
        name: 'series1',
        data: props.total ?? []
      }]
    const options: ApexOptions = {
        colors: props.colors ?? [props.color],
        theme: { mode },
        grid: { borderColor: isDark ? "#3a3a3a" : "#e5e7eb" },
        legend: { labels: { colors: axisColor } },
        chart: {
          background: "transparent",
          foreColor: axisColor,
          toolbar: {
            show: false
          }, 
          height: 350,
          type: props.type
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'datetime',
          categories: props.date ?? [],
          labels: {
            formatter(value, timestamp, opts) {
              let date = new Date();
              const minTimestamp = new Date('2020-01-01').getTime();
              const maxTimestamp = new Date('2100-01-01').getTime();
              if (typeof value === 'number' && Number.isFinite(value) && value >= minTimestamp && value <= maxTimestamp) {
                date = new Date(value);
              } else if (typeof value === 'string' && !Number.isNaN(Date.parse(value))) {
                date = new Date(value);
              }
              
              let year = date.getFullYear();
              let month = date.getMonth() + 1;
              let day = date.getDate();
              return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
            },
          }
        },
        yaxis: {
          labels: {
            formatter: (value) => formatNumber(value),
          },
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd'
          },
          y: {
            formatter: (value) => formatNumber(value),
          },
        },
      }
    return <div>
        <ReactApexChart options={options} series={series} type={props.type} height={450}/>
    </div>
}

export default AreaChart;
